/* eslint-disable no-useless-catch */
import { API } from "../api";
import { TPL_INVOICE_URL } from "../constants/url.constant";

const REQUEST_DATA = "REQUEST_DATA";
const REQUEST_TOTAL_DATA = "REQUEST_TOTAL_DATA";
const ADD_TPL_INVOICE = "ADD_TPL_INVOICE";
const GET_TPL_INVOICES = "GET_TPL_INVOICES";
const GET_TOTAL_CHARGES = "GET_TOTAL_CHARGES";
const DELETE_TPL_INVOICE = "DELETE_TPL_INVOICE";
const UPDATE_TPL_INVOICE = "UPDATE_TPL_INVOICE";

export const addInvoice = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(TPL_INVOICE_URL, data);
      dispatch(addInvoiceList(data));
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeInvoice = (regionCode) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${TPL_INVOICE_URL}/${regionCode}`);
      dispatch(deleteInvoice(regionCode));
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addInvoiceList = (data) => ({
  type: ADD_TPL_INVOICE,
  payload: data
});

export const updateInvoice = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${TPL_INVOICE_URL}/${code}`, body);
      dispatch({ type: UPDATE_TPL_INVOICE, payload: { code, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const deleteInvoice = (code) => ({
  type: DELETE_TPL_INVOICE,
  payload: code
});

export const getTotalCharges = (filter = {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REQUEST_TOTAL_DATA });
      const res = await API.post(`${TPL_INVOICE_URL}/total-charges`, filter);
      if (Object.keys(filter).length) {
        dispatch({
          type: GET_TOTAL_CHARGES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getInvoices = (filter = {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REQUEST_DATA });
      const res = await API.post(TPL_INVOICE_URL, filter);
      if (Object.keys(filter).length) {
        dispatch({
          type: GET_TPL_INVOICES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getOrders = (filter = {}) => {
  return async (dispatch) => {
    try {
      dispatch({ type: REQUEST_DATA });
      const res = await API.post(`${TPL_INVOICE_URL}/orders`, filter);
      if (Object.keys(filter).length) {
        dispatch({
          type: GET_TPL_INVOICES,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = {
    rows: [],
    totalRows: 0,
    isLoading: false,
    isTotalLoading: false,
    totalTPLCharges: 0,
    totalReceivables: 0,
  },
  { type, payload }
) {
  switch (type) {
    case REQUEST_DATA:
      return {
        ...state,
        isLoading: true
      };
    case REQUEST_TOTAL_DATA:
      return {
        ...state,
        isTotalLoading: true
      };
    case GET_TPL_INVOICES:
      return {
        ...state,
        isLoading: false,
        columns: payload.columns,
        rows: payload.rows,
        totalRows: payload.count,
        tplIds: payload.tplIds,
        isMultipleTPL: payload.isMultipleTPL,
      };
    case GET_TOTAL_CHARGES:
      return {
        ...state,
        isTotalLoading: false,
        totalCODAmount: payload.totalCODAmount,
        totalTPLCharges: payload.totalTPLCharges,
        totalReceivables: payload.totalReceivables
      };
    case ADD_TPL_INVOICE:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        rows: [
          ...state.rows,
          { code: payload.code, name: payload.name }
        ]
      };
    case DELETE_TPL_INVOICE:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        rows: state.rows.filter(
          (invoice) => invoice.code !== payload
        )
      };
    case UPDATE_TPL_INVOICE:
      return {
        ...state,
        rows: state.rows.map((invoice) =>
          invoice.code === payload.code
            ? { "country.name": invoice["country.name"], ...payload }
            : invoice
        )
      };
    default:
      return state;
  }
}
